import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import LightBox from '@aytm/lib/rfd-ui/components/basic/light-box'
import ImagePopup from '@aytm/lib/rfd-ui/components/basic/image-popup'

// <Component>

const FRAME_PADDING = 7
const SCROLLING_PADDING = 30
const LABEL_HEIGHT = 40

export default class HeatMapPopup extends ImagePopup {
  static propTypes = {
    src: PropTypes.string.isRequired,
    imgOriginalHeight: PropTypes.number.isRequired,
    imgOriginalWidth: PropTypes.number.isRequired,
    svgContent: PropTypes.string,
    show: PropTypes.bool.isRequired,
    showImg: PropTypes.bool.isRequired,
    scrolling: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    closeOnClick: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      ...this.state,
      opacityImg: 0
    }
  }

  componentDidMount() {
    const { showImg } = this.props
    super.componentDidMount()
    window.addEventListener('resize', this.handleWindowResize)
    if (showImg) {
      setTimeout(() => this.setState({ opacityImg: 1 }), 0)
    }
  }

  render() {
    const {
      src,
      label,
      show,
      scrolling,
      loadingIcon = 'icon-aytmfd-refresh-v2 aytmfd-spin',
      failedIcon = 'icon-aytmfd-delete',
      closeIcon = 'icon-aytmfd-delete',
      closeOnClick = false,
      imgOriginalWidth,
      imgOriginalHeight,
      svgContent
    } = this.props
    const { loading, loaded, imageWidth, imageHeight, opacityImg } = this.state
    if (show) {
      const iWidth = imageWidth + (scrolling ? SCROLLING_PADDING : 0)
      const iHeight = imageHeight + (label && loaded ? LABEL_HEIGHT : 0)
      const scaleLightBox = iWidth / imgOriginalWidth

      return (
        <LightBox onClose={this.handleClose} fullSize={scrolling}>
          <div
            ref={this.saveRef('ImageFrame')}
            className={classNames('rfd-ui-image-popup-frame', {
              'rfd-ui-image-popup-frame-loading': loading,
              'rfd-ui-image-popup-frame-loaded': loaded,
              'rfd-ui-image-popup-frame-scrolling': loaded && scrolling
            })}
            style={{
              width: `${iWidth}px`,
              height: `${iHeight}px`,
              margin: `-${iHeight / 2 + FRAME_PADDING}px 0 0 -${iWidth / 2 + FRAME_PADDING}px`,
              padding: `${FRAME_PADDING}px`
            }}
            onClick={closeOnClick ? this.handleClose : null}
          >
            <svg
              style={{
                position: 'absolute',
                top: `${FRAME_PADDING}px`,
                left: `${FRAME_PADDING}px`,
                transformOrigin: 'left top',
                transform: `scale(${scaleLightBox}) translateZ(0)`
              }}
              width={imgOriginalWidth}
              height={imgOriginalHeight}
              viewBox={`0 0 ${imgOriginalWidth} ${imgOriginalHeight}`}
              dangerouslySetInnerHTML={{ __html: svgContent }}
            />

            <div className="rfd-ui-image-popup-close-button" onClick={closeOnClick ? null : this.handleClose}>
              <i className={closeIcon} />
            </div>

            <img
              src={src}
              width={`${imageWidth}px`}
              height={scrolling ? 'auto' : `${imageHeight}px`}
              onLoad={this.onLoad}
              onError={this.onError}
              style={{ opacity: opacityImg }}
            />

            {loading && !loaded && (
              <div className="rfd-ui-image-popup-image-loader">
                <i className={loadingIcon} />
              </div>
            )}
            {!loading && !loaded && (
              <div className="rfd-ui-image-popup-image-failed">
                <i className={failedIcon} />
              </div>
            )}
          </div>
        </LightBox>
      )
    } else return null
  }
}
